module.exports = __webpack_public_path__ + "img/edit.6e38a7d8.svg";